import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  SpacingBox,
  ClickableFlexBox,
  H3,
  PlusCircleIcon,
} from '../../Components';
import { routes } from '../../routes';
import { translate } from './translate';

export const CreateNewOrderButton = withRouter(({ history }) => {
  const routeToOrderCreation = () => history.push(routes.orderCustomerSelection);
  return (
    <SpacingBox>
      <ClickableFlexBox onClick={routeToOrderCreation}>
        <SpacingBox marginBottom="sm" marginRight="md">
          <PlusCircleIcon size="md" />
        </SpacingBox>
        <H3>{translate('newOrder')}</H3>
      </ClickableFlexBox>
    </SpacingBox>
  );
});
